import './Theme.Page.Error.scss';
export default 'ThemePageError';
